import { rootApi } from './rootApi';

export const customerApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getCustomers: builder.query({
            query: (params = {}) => ({
                url: 'v1/customer/getcustomer',
                method: 'GET',
                params: {
                    ChassisNo: params.ChassisNo ? String(params.ChassisNo).trim() : '',
                    Surname: params.Surname ? String(params.Surname).trim() : '',
                    Name: params.Name ? String(params.Name).trim() : '',
                    PageSize: params.PageSize || 10,
                    PageNumber: params.PageNumber || 1
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return {
                        items: response.data.items || [],
                        totalCount: response.data.totalCount || 0
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['Customer']
        }),
        exportCustomer: builder.query({
            query: (params) => ({
                url: 'v1/customer/exportCustomer',
                method: 'GET',
                params: {
                    ChassisNo: params.ChassisNo ? String(params.ChassisNo).trim() : '',
                    Surname: params.Surname ? String(params.Surname).trim() : '',
                    Name: params.Name ? String(params.Name).trim() : '',
                    LicensePlate: params.LicensePlate ? String(params.LicensePlate).trim() : '',
                    DealerId: params.DealerId ?? null,
                    StartDate: params.StartDate ?? null,
                    EndDate: params.EndDate ?? null,
                    LanguageId: params.LanguageId,
                    CompressionType: params.CompressionType ?? 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const data = response.data;
                    return {
                        fileBase64: data.fileBase64,
                        fileName: data.fileName,
                        contentType: data.contentType,
                        recordCount: data.recordCount,
                        fileSize: data.fileSize,
                        isCompressed: data.isCompressed
                    };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        }),

        getCustomerDropdown: builder.query({
            query: (params = {}) => ({
                url: 'v1/customer/getcustomer',
                method: 'GET',
                params: {
                    ChassisNo: params.ChassisNo ? String(params.ChassisNo).trim() : '',
                    Surname: params.Surname ? String(params.Surname).trim() : '',
                    Name: params.Name ? String(params.Name).trim() : '',
                    PageSize: params.PageSize || 50,
                    PageNumber: params.PageNumber || 1,
                    SearchText: params.SearchText ? String(params.SearchText).trim() : ''
                }
            }),
            transformResponse: (response) => (response?.isSuccessful && response?.data?.items ? response.data.items : []),
            providesTags: ['Customer']
        }),

        addCustomer: builder.mutation({
            query: (formData) => {
                const chassisArray = Array.isArray(formData.chassisList)
                    ? formData.chassisList.map((item) => ({
                          chassisNo: String(item.chassisNo || ''),
                          licensePlate: String(item.licensePlate || '')
                      }))
                    : [];

                return {
                    url: 'v1/customer/create',
                    method: 'POST',
                    body: {
                        name: String(formData.firstName || ''),
                        surname: String(formData.lastName || ''),
                        identityNo: String(formData.tcNumber || ''),
                        phoneNumber: String(formData.phone || ''),
                        address: String(formData.address || ''),
                        country: String(formData.country?.text || formData.country || ''),
                        city: formData.city ? String(formData.city) : null,
                        zipCode: String(formData.postalCode || ''),
                        customerType: formData.customerType ? Number(formData.customerType) : 1,
                        taxOffice: formData.taxOffice ? String(formData.taxOffice) : null,
                        taxNumber: formData.taxNumber !== undefined && formData.taxNumber !== null ? String(formData.taxNumber) : null,
                        partsDiscountRate: formData.partsDiscountRate !== undefined && formData.partsDiscountRate !== null ? Number(formData.partsDiscountRate) : null,
                        laborDiscountRate: formData.laborDiscountRate !== undefined && formData.laborDiscountRate !== null ? Number(formData.laborDiscountRate) : null,
                        chassis: chassisArray
                    }
                };
            },
            transformResponse: (response) => {
                if (response?.isSuccessful) return response.data;
                throw new Error(response?.message || '');
            },
            invalidatesTags: ['Customer']
        }),

        updateCustomer: builder.mutation({
            query: (formData) => {
                const chassisArray = Array.isArray(formData.chassisList)
                    ? formData.chassisList.map((item) => ({
                          chassisNo: String(item.chassisNo || ''),
                          licensePlate: String(item.licensePlate || '')
                      }))
                    : [];

                return {
                    url: 'v1/customer/update',
                    method: 'POST',
                    body: {
                        id: Number(formData.id) || 0,
                        name: String(formData.firstName || ''),
                        surname: String(formData.lastName || ''),
                        identityNo: String(formData.tcNumber || ''),
                        phoneNumber: String(formData.phone || ''),
                        address: String(formData.address || ''),
                        country: String(formData.country?.text || formData.country || ''),
                        city: formData.city ? String(formData.city) : null,
                        zipCode: String(formData.postalCode || ''),
                        customerType: formData.customerType ? Number(formData.customerType) : 1,
                        taxOffice: formData.taxOffice ? String(formData.taxOffice) : null,
                        taxNumber: formData.taxNumber !== undefined && formData.taxNumber !== null ? String(formData.taxNumber) : null,
                        partsDiscountRate: formData.partsDiscountRate !== undefined && formData.partsDiscountRate !== null ? Number(formData.partsDiscountRate) : null,
                        laborDiscountRate: formData.laborDiscountRate !== undefined && formData.laborDiscountRate !== null ? Number(formData.laborDiscountRate) : null,
                        chassis: chassisArray
                    }
                };
            },
            transformResponse: (response) => {
                if (response?.isSuccessful) return response.data;
                throw new Error(response?.message || '');
            },
            invalidatesTags: ['Customer']
        }),

        deleteCustomer: builder.mutation({
            query: (id) => ({
                url: 'v1/customer/delete',
                method: 'POST',
                body: {
                    id: Number(id) || 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful) return response.data;
                throw new Error(response?.message || '');
            },
            invalidatesTags: ['Customer']
        }),

        getCustomerTypes: builder.query({
            query: (languageId = 2) => ({
                url: 'v1/customer/types',
                method: 'GET',
                params: { languageId: Number(languageId) }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                return [];
            },
            providesTags: ['Customer']
        }),

        getCustomerById: builder.query({
            query: (id) => ({
                url: 'v1/customer/GetCustomerById',
                method: 'GET',
                params: { Id: id }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                return null;
            }
        })
    }),
    overrideExisting: false
});

export const { useGetCustomersQuery, useLazyGetCustomersQuery, useGetCustomerDropdownQuery, useAddCustomerMutation, useUpdateCustomerMutation, useDeleteCustomerMutation, useGetCustomerTypesQuery, useLazyExportCustomerQuery, useGetCustomerByIdQuery } = customerApi;
